export const SIZE_PER_PAGE_KEY = 'sizePerPage';

export default {
    pageSize: 10,
    pageNumber: 1
};
